import {
  BaSeBox,
  BaSeBreakpointContext,
  BaSeContainer,
  BaSeDrawer,
  BaSeSideMenu,
  BaSeTheme,
} from '@base/react';
import * as React from 'react';
import { useControlPanelMenu } from '../helpers/control-panel-menu-helper';
import * as Styled from '../styled/control-panel-layout-styled';

const {
  defaultColors: { white },
  institucionais: { cinzaSebrae90 },
} = BaSeTheme.colors;

export const ControlPanelContainer: React.FC = ({ children }) => {
  const { inTablet } = React.useContext(BaSeBreakpointContext);
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const closeDrawer = React.useCallback(() => setDrawerOpen(false), []);

  const { menuItems } = useControlPanelMenu(closeDrawer);

  const renderMenuContent = React.useCallback(
    () => <BaSeSideMenu itens={menuItems} themeMode="light" />,
    [menuItems],
  );

  return (
    <>
      <Styled.BodyInner>
        {inTablet && (
          <Styled.MenuSidebar>
            <BaSeBox
              backgroundColor={white}
              borderColor={cinzaSebrae90}
              shadowLevel={0}
              elevationOnHoverOrFocus={false}
              renderContent={renderMenuContent}
            />
          </Styled.MenuSidebar>
        )}

        <Styled.ContentWrapper>{children}</Styled.ContentWrapper>
      </Styled.BodyInner>

      {!inTablet && (
        <Styled.MenuDrawerWrapper>
          <BaSeDrawer
            anchor="left"
            pullerPosition="start"
            width={260}
            height="100%"
            open={drawerOpen}
            onToggle={setDrawerOpen}
          >
            <BaSeContainer>{renderMenuContent()}</BaSeContainer>
          </BaSeDrawer>
        </Styled.MenuDrawerWrapper>
      )}
    </>
  );
};
